// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"2ce1eb63","453":"20546b69","794":"1115eb1c"}[chunkId] + ".chunk.js";
};